import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../spinners/SpinnerCircle.vue.js';

/**
* @deprecated Use SdsButton or SdsButtonText instead
*/
var script = defineComponent({
    name: 'SbButton',
    props: {
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        disableOnLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        isBlockButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        isTextButton: {
            type: Boolean,
            required: false,
            default: false,
        },
        type: {
            type: String,
            required: false,
            default: 'button',
        },
        size: {
            type: String,
            required: false,
            default: 'medium',
        },
        iconPlacement: {
            type: String,
            required: false,
            default: '',
        },
        theme: {
            type: String,
            required: false,
            default: 'primary',
        },
    },
    computed: {
        shouldDisable: function () {
            return this.disabled || (this.isLoading && this.disableOnLoading);
        },
        spinnerSize: function () {
            if (this.size === 'medium') {
                return '20';
            }
            if (this.size === 'small') {
                return '16';
            }
            return '24';
        },
        spinnerColor: function () {
            var _a;
            var defaultColor = '#ffffff';
            var themeToColor = {
                accent: '#000000',
                secondary: '#000000',
                ghost: '#000000',
            };
            var color = (_a = themeToColor[this.theme]) !== null && _a !== void 0 ? _a : defaultColor;
            return color;
        }
    },
    components: {
        SpinnerCircle: __vue_component__,
    }
});

export default script;
